import * as React from "react";
import {
    Skeleton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import emptyList from "../../assets/lottie/notFund.json";
import {css} from "@emotion/css";
import Box from "@mui/material/Box";
import Pagination from '@mui/material/Pagination';
import PropTypes from "prop-types";
import {useRef, useState} from "react";
import useDraggableScroll from "use-draggable-scroll";
import {Player} from "@lottiefiles/react-lottie-player";

export const RaikoCustomTable = (
    {
        header,
        data,
        rowClicked,
        isLoading = false,
        pageCount = 0,
        handlePaginationChange,
        className
    }) => {

    function prepareTableHeader() {
        return <TableHead>
            <TableRow>
                {header.map((column) => (
                    <TableCell
                        key={column.id}
                        align={column.align}
                        style={{minWidth: column.minWidth}}
                    >
                        {column.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>;
    }

    const ref = useRef(null);
    const {onMouseDown} = useDraggableScroll(ref, {direction: 'horizontal'});

    const [page, setPage] = useState(1);

    return (
        <section

            className={`${
                css`
                  flex-grow: 1 !important;
                  overflow-y: hidden;
                  overflow-x: scroll !important;
                  max-width: 95vw !important;
                `
            } ${className}`}>
            {data.length > 0 && !isLoading ?
                <div

                    className={css`
                      display: flex;
                      flex-direction: column;
                    `}>
                    <TableContainer ref={ref} onMouseDown={onMouseDown} className="hideScroll">
                        <Table stickyHeader aria-label="sticky table">
                            {prepareTableHeader()}
                            <TableBody>
                                {data.map((row, index) => {

                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={row.id}
                                            className='cursorPointer'
                                        >
                                            {header.map((column) => {

                                                const value = row[column.id];
                                                return (
                                                    <TableCell
                                                        key={column.id}
                                                        align={column.align}
                                                        className={
                                                            typeof value === 'object' ?
                                                                css`cursor: default !important;` : ``
                                                        }
                                                        onClick={_ => {
                                                            if (typeof value !== 'object') {
                                                                if (rowClicked) {
                                                                    rowClicked(row.id)
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        {column.id == "id" ? index + 1 : value}

                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <div
                        className={css`
                          width: 100%;
                          display: flex;
                          justify-content: center;
                          align-content: center;
                          margin-top: 16px;
                        `}>
                        <Pagination
                            count={pageCount}
                            shape="rounded"
                            page={page}
                            onChange={(event, value) => {
                                setPage(value)
                                handlePaginationChange(value - 1)
                            }}
                            className={pageCount && pageCount > 0 ? "" : css`display: none`}
                        />
                    </div>

                </div>
                :
                <div className='w-100 h-100' style={{display: 'grid', placeItems: 'center'}}>
                    {isLoading ?
                        <>
                            <Box className={css`width: 100%;
                              padding: 0 16px;
                              gap: 16px;
                              display: flex;
                              flex-direction: column`}>
                                <Skeleton variant="rectangular" className={css`padding: 32px`}/>
                                <Skeleton variant="rectangular" className={css`padding: 16px`}/>
                                <Skeleton variant="rectangular" className={css`padding: 16px`}/>
                                <Skeleton variant="rectangular" className={css`padding: 16px`}/>
                                <Skeleton variant="rectangular" className={css`padding: 16px`}/>
                                <Skeleton variant="rectangular" className={css`padding: 16px`}/>
                            </Box>
                        </>
                        :
                        <section
                            className={css`
                              margin: 0 16px !important;
                              width: 100%;
                            `}
                        >
                            <div
                                className={css`
                                  display: flex;
                                  flex-direction: column;
                                  border: 2px dashed var(--outlined-input-border-color);
                                  transition: var(--base-transition);
                                  border-radius: var(--default-border-radius);
                                  margin: 0 16px !important;
                                  padding: 16px 8px !important;
                                `}
                                style={{justifyContent: 'center', alignItems: 'center'}}>
                                <Player
                                    src={emptyList}
                                    loop
                                    autoplay
                                    style={{height: '200px', width: '200px'}}
                                />
                                <span
                                    className={css`
                                      font-size: var(--text-size-medium);
                                      color: var(--color-text);
                                      margin: 8px 0;
                                      transition: var(--base-transition);
                                    `}>
                                    هیچ اطلاعاتی یافت نشد !
                                </span>
                                <span
                                    className={css`
                                      font-size: var(--text-size-default);
                                      color: var(--color-variant);
                                      margin: 8px 0;
                                      transition: var(--base-transition);
                                    `}>
                                    فیلتر ها را تغییر دهید یا از کلمات متداول تر برای جستجو استفاده نمایید.
                                </span>
                            </div>
                        </section>
                    }
                </div>
            }
        </section>

    )
};
export default RaikoCustomTable;

RaikoCustomTable.propTypes = {
    header: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired
}
